import { render, staticRenderFns } from "./DrawTool.vue?vue&type=template&id=4afcd11e&scoped=true"
import script from "./DrawTool.vue?vue&type=script&lang=js"
export * from "./DrawTool.vue?vue&type=script&lang=js"
import style0 from "./DrawTool.vue?vue&type=style&index=0&id=4afcd11e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afcd11e",
  null
  
)

export default component.exports